
import { IonButton, IonCol, IonContent, IonGrid, IonInput, IonLabel, IonPage, IonRow, IonText, useIonRouter } from '@ionic/react';
import React, { useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { Link } from "react-router-dom";
import Footer from '../../components/Footer';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import AuthServ from '../../services/auth';

interface InitPsResetProps {
  singIn: any,
  user?: User | null,
  refresh: any
}

const InitPsReset: React.FC<InitPsResetProps> = (props) => {

  const history = useIonRouter();


  const siteText = translation();

  const lan = siteText.lan.replace("/", "")

  const [disabled, setDisabled] = useState<boolean>(false);



  const authServ = new AuthServ();

  /**Define form fields */
  interface loginForm {
    email: string,
    password: string
  };

  const { control, handleSubmit } = useForm<loginForm>();
  const [isLogginInError, setIsLogginError] = useState<boolean>(false);



  const onSubmit: SubmitHandler<loginForm> = async (data) => {
    setDisabled(true);
    let auth = false;
    await authServ.requestPsChange(data.email, siteText.lan).then(resp => {
      if (resp.message) {
        auth = true;
      } else {
        setIsLogginError(true);
        return
      }
    });
    if (auth) {
      history.push(`/${lan}/set_new_password`, 'forward', 'replace');
      setDisabled(false);
    }
    return
  }

  const LoginError = () => {
    if (isLogginInError) {
      setDisabled(false)
      return (
        <p>{siteText.requestNewPasswordError}</p>
      )
    } else {
      return <></>;
    }

  }

  return (
    <>
      <IonPage className='pageContent'>
        <IonContent>
          <IonGrid className='sw_sp_md'>
            <IonRow className='ion-justify-content-center ion-align-items-center'>
              <IonCol sizeSm='6' sizeMd="4" className=''>
                <h1 className='ion-text-center'>{siteText.requestNewPasswordTitle}</h1>
                <IonText color={isLogginInError ? 'danger' : 'success'}>
                  <LoginError></LoginError>
                </IonText>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <IonLabel className='ion-margin-top'>{siteText.requestNewPasswordEmailLabel}:</IonLabel>
                  <Controller
                    control={control}
                    name="email"
                    rules={{
                      required: true,
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        message: siteText.requestNewPasswordInvalidEmail
                      }
                    }}

                    render={({ field: { onChange, onBlur, value } }) => (
                      <IonInput
                        className='ion-margin-top ion-margin-bottom'
                        type="email"
                        placeholder={siteText.requestNewPasswordEmailPlaceHolder}

                        value={value}
                        onIonBlur={onBlur}
                        onIonChange={onChange}
                      />
                    )}


                  />
                  <div className="ion-margin-top">
                    <IonButton disabled={disabled} type="submit">{siteText.requestNewPasswordprimaray}</IonButton>
                    <IonText className=''><Link className='ion-padding' to={`/${lan}/set_new_password`}>{siteText.requestNewPasswordSecondary}</Link> </IonText>
                  </div>
                </form>

              </IonCol>
            </IonRow>
          </IonGrid>
          <Footer></Footer>
        </IonContent>
      </IonPage>

    </>);




};

export default InitPsReset;
